@if (!offerContentConfiguration?.isBetMgmTileRedesignEnabled && sportsNameAndGameTypes) {
    <div class="offer-badge txt-s">
        <span class="sportsnameandtypes">{{ sportsNameAndGameTypes }}</span>
    </div>
}
